export const onBoardinfVideosJSON = [
  {
    id: 1,
    title: "Downloading and Installing Software",
    description:
      "Step-by-step onboarding: how to download and install ChinookDT.",
    link: "/videos/onBoarding/1. Downloading and Installing Software.mp4",
  },
  {
    id: 2,
    title: "GA Software Voice Over",
    description: "Learn the basics of General Arrangement (GA) in ChinookDT.",
    link: "/videos/onBoarding/3. GA Software_Voice Over.mp4",
  },
  {
    id: 3,
    title: "Structural Software Voice Over",
    description: "Explore structural design workflows using ChinookDT.",
    link: "/videos/onBoarding/4. Structural Software_Voice Over.mp4",
  },
  {
    id: 4,
    title: "Pressure Vessel Software Onboarding",
    description: "Quickstart guide to pressure vessel projects in ChinookDT.",
    link: "/videos/onBoarding/6. Pressure Vessel Software Onboarding Video.mp4",
  },
  {
    id: 5,
    title: "Tank Software Demo – Edited",
    description:
      "Refined walkthrough of tank design and execution in ChinookDT.",
    link: "/videos/onBoarding/tank software demo - edited.mp4",
  },
];
